import * as React from "react";
import { graphql } from "gatsby";

import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import CBreadcrumb from "../components/CBreadcrumb";

import MainDecorator from "../components/MainDecorator";
import ResponsiveArticleListing2Col from "../components/ResponsiveArticleListing2Col";
import ConditionalBorderGrid from "../components/ConditionalBorderGrid";
import { SEO } from "../components/HeadMeta";
import HubspotContactForm from "../components/HubspotSubscribeForm";

export const Head = ({ data, pageContext }) => {
    return <SEO pathname={pageContext.pagePath} />;
};

const CategoryPage = ({ data, pageContext }) => {
    return (
        <MainDecorator>
            <CBreadcrumb title={pageContext.category} />
            <Typography
                variant="h2"
                component="h2"
                gutterBottom
                sx={{ textTransform: "capitalize" }}
            >
                {pageContext.category}
            </Typography>
            <Grid container maxWidth="lg">
                <ConditionalBorderGrid item xs={12} md={8}>
                    {data.results.posts.map(({ post }) => (
                        <ResponsiveArticleListing2Col
                            key={post.id}
                            post={post}
                        />
                    ))}
                </ConditionalBorderGrid>
                <Grid item md={4} xs={12} sx={{ pl: 2 }}>
                    <HubspotContactForm />
                </Grid>
            </Grid>
        </MainDecorator>
    );
};
export const query = graphql`
    query ByCategory($category: String!) {
        results: allMarkdownRemark(
            sort: { frontmatter: { created: DESC } }
            limit: 100
            skip: 0
            filter: { frontmatter: { categories: { in: [$category] } } }
        ) {
            posts: edges {
                post: node {
                    excerpt
                    id
                    fields {
                        path
                    }

                    frontmatter {
                        tags
                        title
                        created
                        categories
                        __typename
                        heroImage: coverImage {
                            childImageSharp {
                                gatsbyImageData(width: 1200)
                            }
                        }
                        thumbImage: coverImage {
                            childImageSharp {
                                gatsbyImageData(width: 400)
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default CategoryPage;
